import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { LANGUAGES } from "@/i18n/languages";

const INCLUDED = LANGUAGES.filter((l) => l.code !== "en").map((l) => l.code).join(",");
const SCRIPT_ID = "google-translate-script";

function setGoogTransCookie(tl) {
  const v = `/en/${tl}`;
  document.cookie = `googtrans=${v};path=/;max-age=31536000`;
  const host = window.location.hostname;
  if (host && host.includes(".")) {
    const root = host.split(".").slice(-2).join(".");
    document.cookie = `googtrans=${v};path=/;domain=.${root};max-age=31536000`;
  }
}

function triggerCombo(tl) {
  const combo = document.querySelector(".goog-te-combo");
  if (!combo) return false;
  if (combo.value !== tl) {
    combo.value = tl;
    combo.dispatchEvent(new Event("change"));
  }
  return true;
}

export default function GoogleStorefrontTranslate({ language }) {
  const loc = useLocation();
  const tl = String(language || "en").split("-")[0];
  const on = Boolean(tl && tl !== "en");

  useEffect(() => {
    if (!on) return undefined;
    setGoogTransCookie(tl);
    window.googleTranslateElementInit = () => {
      const TE = window.google?.translate?.TranslateElement;
      const host = document.getElementById("google_translate_element");
      if (!TE || !host) return;
      host.innerHTML = "";
      const widget = new TE({ pageLanguage: "en", includedLanguages: INCLUDED, autoDisplay: false }, "google_translate_element");
      void widget;
      window.setTimeout(() => triggerCombo(tl), 500);
    };
    if (!document.getElementById(SCRIPT_ID)) {
      const s = document.createElement("script");
      s.id = SCRIPT_ID;
      s.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      s.async = true;
      document.body.appendChild(s);
    } else if (window.google?.translate?.TranslateElement) {
      window.googleTranslateElementInit();
    }
    return undefined;
  }, [on, tl]);

  useEffect(() => {
    if (!on) return undefined;
    const t = window.setTimeout(() => triggerCombo(tl), 700);
    return () => window.clearTimeout(t);
  }, [loc.pathname, loc.search, on, tl]);

  if (!on) return null;
  return <div id="google_translate_element" data-testid="google-storefront-translate" className="sf-gt-widget" aria-hidden />;
}
